
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import ProfileButton from "@/components/auth/ProfileButton";
import { cn } from "@/lib/utils";

interface SettingsHeaderProps {
  enableRpgMode: boolean;
  darkMode: boolean;
}

const SettingsHeader: React.FC<SettingsHeaderProps> = ({ enableRpgMode, darkMode }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-md flex justify-between items-center mb-4">
      <Button 
        variant="ghost" 
        className={cn(
          "font-medium transition-colors",
          enableRpgMode ? (
            darkMode 
              ? "text-amber-200 hover:text-amber-100 hover:bg-amber-600/20" 
              : "text-amber-800 hover:text-amber-900 hover:bg-amber-200/20"
          ) : (
            darkMode 
              ? "text-[#FBF3F1] hover:text-white hover:bg-white/10" 
              : "text-[#1E0C46] hover:text-[#1E0C46] hover:bg-[#1E0C46]/10"
          )
        )}
        onClick={() => navigate('/')}
      >
        Return to Hub
      </Button>
      
      <div className="ml-auto">
        <ProfileButton />
      </div>
    </div>
  );
};

export default SettingsHeader;
